<template>
  <div v-if="item" :data-id="item.prodID">
    <a v-if="removable" class="remove-item" href="#" @click="removeItem">
      <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>
    </a>
    <div class="cart-stylename" v-html="item.datamann_desc"></div>
    <div>
      <div class="cart-image">
        <a :href="item.url"
          itemprop="url"
          @click="onProductClick" >
          <img class="img-responsive"
             :src="item.image_url"
            :alt="item.datamann_desc"
            itemprop="image">
        </a>
      </div>
      <div class="cart-description">
        <div v-if="item.is_product" class="cart-item-size">
          <label>Size:</label> <span v-html="item.stylesize"></span>
        </div>
        <div v-if="item.is_product" class="cart-item-color">
          <label>Color:</label> <span v-html="item.colorname"></span>
        </div>
        <div class="cart-item-price">
          <label>Price:</label>
            <span class="regular-price"
              v-html="item.adjusted_priceCurrency">
            </span>
            <s v-if="item.discounted" class="text-muted"
               v-html="item.original_priceCurrency"></s>
        </div>
        <slot name="description"></slot>
      </div>
      <slot name="additional"></slot>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
import { handleProductClick } from '../module/util'

export default {
    props: {
        removable: {
            type: Boolean,
            default: false,
        },
        item: {
            type: Object,
            default: null
        },
    },

    data () {
        return {
        }
    },

    methods: {
        removeItem () {
            this.$emit('removeItem', this.item)
        },
        onProductClick () {
            handleProductClick()
        },
    },
}
</script>
